// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --appBlack: #000000;
  --inactiveIcon: #8a8c91;
  --activeIcon: white;
  --activeIconRed: red;
  --popupBackground: #2d2f39;
  --legendRed: #e72416;
  --legendYellow: #ffe08f;
  --frontBlue: #0178ae;
  --legendGreen: #83b643;
  --lighterGreen: #8cff0053;
  --textDetails: #ec6728;
  --inputError: #d60d25;
  --inputSuccess: #12b76a;
  --statusBlue: #3f7bf3;
  --sectionHeadlineText: #54778e;
  --sfOrangeLight: #ff8e58;
  --badgeBg: #f7ddd0;
}

.BulkExternalNotes-module_root___s8ZpV {
  width: 1100px;
  max-width: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
}

.BulkExternalNotes-module_top___m5sxd {
  display: flex;
  padding: 2rem 0;
  overflow: auto;
}
@media (max-width: 900px) {
  .BulkExternalNotes-module_top___m5sxd {
    flex-direction: column;
  }
}

.theme--light .BulkExternalNotes-module_left___vpeF8 {
  border-right: 1px solid #dddddd;
  flex: 1;
  min-width: 200px;
  padding: 0 2rem;
  padding-top: 2rem;
  user-select: none;
}
.theme--dark .BulkExternalNotes-module_left___vpeF8 {
  border-right: 1px solid #2f2f2f;
  flex: 1;
  min-width: 200px;
  padding: 0 2rem;
  padding-top: 2rem;
  user-select: none;
}

.BulkExternalNotes-module_right___BTRGw {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 420px;
  padding: 0 2rem;
  padding-top: 2rem;
}

.BulkExternalNotes-module_mb___sbtEV {
  margin-bottom: 16px;
}

.theme--light .BulkExternalNotes-module_subHeader___NcEUv {
  color: #212121;
  font-size: 1.6rem;
  font-weight: 600;
}
.theme--dark .BulkExternalNotes-module_subHeader___NcEUv {
  color: #f0f0f0;
  font-size: 1.6rem;
  font-weight: 600;
}

.theme--light .BulkExternalNotes-module_subHeaderSecondary____M4dw {
  color: #888888;
  font-size: 1.4rem;
}
.theme--dark .BulkExternalNotes-module_subHeaderSecondary____M4dw {
  color: #a3a3a3;
  font-size: 1.4rem;
}

.BulkExternalNotes-module_traitsHeader___hTEwU {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;
  gap: 6px;
}

.BulkExternalNotes-module_selectAll___ZZyP9 {
  color: var(--textDetails);
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 500;
  flex-shrink: 0;
}

.BulkExternalNotes-module_selectAll___ZZyP9:hover {
  text-decoration: underline;
}

.BulkExternalNotes-module_textArea___gHroW {
  resize: vertical;
  width: 100%;
  min-height: 90px;
  border-radius: 4px;
  padding: 8px;
  font-size: 1.4rem;
}
.theme--light .BulkExternalNotes-module_textArea___gHroW {
  border: 1px solid #dddddd;
  background-color: #ffffff;
  color: #212121;
}
.theme--dark .BulkExternalNotes-module_textArea___gHroW {
  border: 1px solid #2f2f2f;
  background-color: #1c1c1c;
  color: #f0f0f0;
}

.BulkExternalNotes-module_textArea___gHroW::placeholder {
  font-size: 1.4rem;
}

.BulkExternalNotes-module_traits___kAumG {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.BulkExternalNotes-module_trait___t3P1R {
  display: flex;
  gap: 8px;
  align-items: center;
  white-space: nowrap;
  font-size: 1.3rem;
  font-weight: 400;
  cursor: pointer;
  user-select: none;
}
.theme--light .BulkExternalNotes-module_trait___t3P1R {
  border: 1px solid #dddddd;
  border-radius: 4px;
  color: #888888;
  padding: 1.2rem;
}
.theme--dark .BulkExternalNotes-module_trait___t3P1R {
  border: 1px solid #2f2f2f;
  border-radius: 4px;
  color: #a3a3a3;
  padding: 1.2rem;
}
.BulkExternalNotes-module_trait___t3P1R.BulkExternalNotes-module_checked___Dxr8e {
  border-color: var(--textDetails);
}
.theme--light .BulkExternalNotes-module_trait___t3P1R.BulkExternalNotes-module_checked___Dxr8e {
  color: #212121;
}
.theme--dark .BulkExternalNotes-module_trait___t3P1R.BulkExternalNotes-module_checked___Dxr8e {
  color: #f0f0f0;
}

.theme--light .BulkExternalNotes-module_warning___ip3iA {
  border: 1px solid #fecdca;
  background: #fef3f2;
  color: #b42318;
  padding: 1.6rem;
  margin-top: 1.6rem;
  border-radius: 6px;
}
.theme--dark .BulkExternalNotes-module_warning___ip3iA {
  border: 1px solid #fecdca;
  background: #fef3f2;
  color: #b42318;
  padding: 1.6rem;
  margin-top: 1.6rem;
  border-radius: 6px;
}

.BulkExternalNotes-module_warningHeader___bVqg_ {
  font-size: 1.4rem;
  font-weight: 600;
}

.BulkExternalNotes-module_warningText___kRsL8 {
  font-size: 1.2rem;
  font-weight: 400;
}

.theme--light .BulkExternalNotes-module_rightTopHeaders___iPhuD {
  border-bottom: 1px solid #dddddd;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 1.6rem;
}
.theme--dark .BulkExternalNotes-module_rightTopHeaders___iPhuD {
  border-bottom: 1px solid #2f2f2f;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 1.6rem;
}

.theme--light .BulkExternalNotes-module_buttons___v_eR_ {
  border-top: 1px solid #dddddd;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding: 2rem;
}
.theme--dark .BulkExternalNotes-module_buttons___v_eR_ {
  border-top: 1px solid #2f2f2f;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding: 2rem;
}

.BulkExternalNotes-module_listings___qirPA {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  overflow: auto;
}

.theme--light .BulkExternalNotes-module_singleListing___m5cqR {
  border-top: 1px solid #dddddd;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 6px;
  padding: 6px;
  font-size: 1.4rem;
}
.theme--dark .BulkExternalNotes-module_singleListing___m5cqR {
  border-top: 1px solid #2f2f2f;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 6px;
  padding: 6px;
  font-size: 1.4rem;
}

.BulkExternalNotes-module_singleListing___m5cqR[data-no-border=true] {
  border: none;
}

.theme--light .BulkExternalNotes-module_xContainer___AtWze {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  width: 30px;
  align-self: stretch;
  align-items: start;
}
.theme--dark .BulkExternalNotes-module_xContainer___AtWze {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  width: 30px;
  align-self: stretch;
  align-items: start;
}
.theme--light .BulkExternalNotes-module_xContainer___AtWze div {
  display: flex;
  align-items: center;
  padding: 2px;
  justify-content: center;
  border-radius: 6px;
  background: #dddddd;
  transition: 200ms;
}
.theme--dark .BulkExternalNotes-module_xContainer___AtWze div {
  display: flex;
  align-items: center;
  padding: 2px;
  justify-content: center;
  border-radius: 6px;
  background: #2f2f2f;
  transition: 200ms;
}
.theme--light .BulkExternalNotes-module_xContainer___AtWze div:hover {
  padding: 2px;
  background: #888888;
}
.theme--dark .BulkExternalNotes-module_xContainer___AtWze div:hover {
  padding: 2px;
  background: #a3a3a3;
}

.BulkExternalNotes-module_itemTextPrimary___mMLgI {
  font-size: 1.4rem;
  font-weight: 500;
}

.BulkExternalNotes-module_secRowSeat___gGkX_ {
  flex-grow: 1;
  min-width: 20px;
}

.BulkExternalNotes-module_headerSecRowSeat___LcfkY {
  padding: 0.6rem;
}

.BulkExternalNotes-module_secRowSeatCont___CwSVY {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.BulkExternalNotes-module_textSecondary___Z7X72 {
  font-size: 1.2rem;
  font-weight: 400;
}

.theme--light .BulkExternalNotes-module_qty___LUc9m {
  color: #888888;
  width: 45px;
  padding: 0.6rem;
  flex-shrink: 0;
}
.theme--dark .BulkExternalNotes-module_qty___LUc9m {
  color: #a3a3a3;
  width: 45px;
  padding: 0.6rem;
  flex-shrink: 0;
}

.theme--light .BulkExternalNotes-module_splitLabel___DeJVR {
  color: #888888;
  width: 60px;
  padding: 0.6rem;
  flex-shrink: 0;
}
.theme--dark .BulkExternalNotes-module_splitLabel___DeJVR {
  color: #a3a3a3;
  width: 60px;
  padding: 0.6rem;
  flex-shrink: 0;
}

.theme--light .BulkExternalNotes-module_priceLabel___MuNK6 {
  color: #888888;
  width: 90px;
  padding: 0.6rem;
  flex-shrink: 0;
}
.theme--dark .BulkExternalNotes-module_priceLabel___MuNK6 {
  color: #a3a3a3;
  width: 90px;
  padding: 0.6rem;
  flex-shrink: 0;
}

.BulkExternalNotes-module_notePills___uiYHg {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  margin-top: 2px;
}

.theme--light .BulkExternalNotes-module_hasNotes___tN9HE {
  color: #888888;
  border: 1px solid #dddddd;
  border-radius: 28px;
  padding: 3px 8px;
  font-size: 1.1rem;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.theme--dark .BulkExternalNotes-module_hasNotes___tN9HE {
  color: #a3a3a3;
  border: 1px solid #2f2f2f;
  border-radius: 28px;
  padding: 3px 8px;
  font-size: 1.1rem;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.BulkExternalNotes-module_noNotes___JDQYL {
  font-style: italic;
  opacity: 0.7;
}

.BulkExternalNotes-module_notePill___a2CMC {
  font-weight: 500;
  font-size: 1.1rem;
  border-radius: 28px;
  padding: 3px 8px;
  white-space: nowrap;
}
.theme--light .BulkExternalNotes-module_notePill___a2CMC {
  border: 1px solid #dddddd;
  background-color: #ddddda;
  color: #212121;
}
.theme--dark .BulkExternalNotes-module_notePill___a2CMC {
  border: 1px solid #2f2f2f;
  background-color: #2f2f2f;
  color: #f0f0f0;
}`, "",{"version":3,"sources":["webpack://./src/styles/_index.scss","webpack://./src/components/bulkExternalNotes/BulkExternalNotes.module.scss"],"names":[],"mappings":"AAOA;EACC,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;ACND;;AAhBA;EACC,aAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAmBD;;AAhBA;EACC,aAAA;EACA,eAAA;EACA,cAAA;AAmBD;AAjBC;EALD;IAME,sBAAA;EAoBA;AACF;;ADmEE;EClFA,+BAAA;EACA,OAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAmBF;AD0DE;EClFA,+BAAA;EACA,OAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AA2BF;;AAvBA;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA0BD;;AAvBA;EACC,mBAAA;AA0BD;;ADoCE;ECzDA,cAAA;EACA,iBAAA;EACA,gBAAA;AAyBF;AD8BE;ECzDA,cAAA;EACA,iBAAA;EACA,gBAAA;AA8BF;;ADyBE;ECjDA,cAAA;EACA,iBAAA;AA4BF;ADoBE;ECjDA,cAAA;EACA,iBAAA;AAgCF;;AA5BA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AA+BD;;AA5BA;EACC,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AA+BD;;AA5BA;EACC,0BAAA;AA+BD;;AA5BA;EAOC,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAyBD;ADdE;ECrBA,yBAAA;EACA,yBAAA;EACA,cAAA;AAsCF;ADnBE;ECrBA,yBAAA;EACA,yBAAA;EACA,cAAA;AA2CF;;AAhCA;EACC,iBAAA;AAmCD;;AAhCA;EACC,aAAA;EACA,qCAAA;EACA,QAAA;AAmCD;;AAhCA;EAQC,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA4BD;AD7CE;ECIA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AA4CF;ADnDE;ECIA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAkDF;AAtCC;EACC,gCAAA;AAwCF;AD5DE;ECuBC,cAAA;AAwCH;AD/DE;ECuBC,cAAA;AA2CH;;ADlEE;EC8BA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAwCF;AD3EE;EC8BA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAgDF;;AA5CA;EACC,iBAAA;EACA,gBAAA;AA+CD;;AA5CA;EACC,iBAAA;EACA,gBAAA;AA+CD;;AD7FE;ECmDA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,sBAAA;AA8CF;ADrGE;ECmDA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,sBAAA;AAqDF;;AD5GE;EC6DA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;AAmDF;ADpHE;EC6DA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;AA0DF;;AAtDA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;AAyDD;;ADlIE;EC8EA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAwDF;AD5IE;EC8EA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAiEF;;AA7DA;EACC,YAAA;AAgED;;ADzJE;EC8FA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AA+DF;ADnKE;EC8FA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAwEF;AD5KE;ECyGC,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAsEH;ADrLE;ECyGC,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AA+EH;AD9LE;ECqHC,YAAA;EACA,mBAAA;AA4EH;ADlME;ECqHC,YAAA;EACA,mBAAA;AAgFH;;AA3EA;EACC,iBAAA;EACA,gBAAA;AA8ED;;AA3EA;EACC,YAAA;EACA,eAAA;AA8ED;;AA3EA;EACC,eAAA;AA8ED;;AA3EA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AA8ED;;AA3EA;EACC,iBAAA;EACA,gBAAA;AA8ED;;AD/NE;ECsJA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AA6EF;ADtOE;ECsJA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAmFF;;AD5OE;EC+JA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAiFF;ADnPE;EC+JA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAuFF;;ADzPE;ECwKA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAqFF;ADhQE;ECwKA,cAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AA2FF;;AAvFA;EACC,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AA0FD;;AD9QE;ECyLA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAyFF;ADzRE;ECyLA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAmGF;;AA/FA;EACC,kBAAA;EACA,YAAA;AAkGD;;AA/FA;EAOC,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AA4FD;ADhTE;EC2MA,yBAAA;EACA,yBAAA;EACA,cAAA;AAwGF;ADrTE;EC2MA,yBAAA;EACA,yBAAA;EACA,cAAA;AA6GF","sourcesContent":["@use \"sass:map\";\r\n\r\n$breakPointM: 1024px;\r\n$breakPointS: 768px;\r\n$breakPointHeightL: 900px;\r\n$breakPointHeightXL: 2200px;\r\n\r\n:root {\r\n\t--appBlack: #000000;\r\n\t--inactiveIcon: #8a8c91;\r\n\t--activeIcon: white;\r\n\t--activeIconRed: red;\r\n\t--popupBackground: #2d2f39;\r\n\t--legendRed: #e72416;\r\n\t--legendYellow: #ffe08f;\r\n\t--frontBlue: #0178ae;\r\n\t--legendGreen: #83b643;\r\n\t--lighterGreen: #8cff0053;\r\n\t--textDetails: #ec6728;\r\n\t--inputError: #d60d25;\r\n\t--inputSuccess: #12b76a;\r\n\t--statusBlue: #3f7bf3;\r\n\t--sectionHeadlineText: #54778e;\r\n\t--sfOrangeLight: #ff8e58;\r\n\t--badgeBg: #f7ddd0;\r\n}\r\n\r\n$themes: (\r\n\tlight: (\r\n\t\tbackgroundPrimary: #f5f6f8,\r\n\t\tsidebarBorder: #dddddd,\r\n\t\ttextPrimary: #212121,\r\n\t\trowWithSoldColor: #212121,\r\n\t\ttextSecondary: #888888,\r\n\t\tborderColor: #dddddd,\r\n\t\tbuttonTertiaryBackground: #ffffff,\r\n\t\tbuttonTertiaryColor: #1f1f1f,\r\n\t\tbuttonTertiaryBorderColor: #e8e8e8,\r\n\t\tinputBackground: #fafafa,\r\n\t\tinputBorderColor: #ddddda,\r\n\t\tsectionBackground: #ffffff,\r\n\t\ttableCellBackground: #ffffff,\r\n\t\ttableHeaderBackground: #f5f6f8,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #cfe1cb,\r\n\t\tholdHighlightedItem: #fff3c4,\r\n\t\trowWithHoldColor: #212121,\r\n\r\n\t\tbuttonPrimaryBackground: #000000,\r\n\t\tbuttonPrimaryBorderColor: #555555,\r\n\t\tbuttonPrimaryTextColor: #ffffff,\r\n\r\n\t\tbuttonSecondaryBackground: #ffffff,\r\n\t\tbuttonSecondaryBorderColor: #dddddd,\r\n\t\tbuttonSecondaryTextColor: #000000,\r\n\r\n\t\tsidebarBackground: #ffffff,\r\n\t\tbuttonOutlineBorder: #8b8b8b,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n\tdark: (\r\n\t\tbackgroundPrimary: #0d0d0d,\r\n\t\tsidebarBorder: #000000,\r\n\t\ttextPrimary: #f0f0f0,\r\n\t\trowWithSoldColor: #f0f0f0,\r\n\t\ttextSecondary: #a3a3a3,\r\n\t\tborderColor: #2f2f2f,\r\n\t\tbuttonTertiaryBackground: #0d0d0d,\r\n\t\tbuttonTertiaryColor: #fafafa,\r\n\t\tbuttonTertiaryBorderColor: #2f2f2f,\r\n\t\tinputBackground: #0d0d0d,\r\n\t\tinputBorderColor: #2f2f2f,\r\n\t\tsectionBackground: #1c1c1c,\r\n\t\ttableCellBackground: #1c1c1c,\r\n\t\ttableHeaderBackground: #1c1c1c,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #4a5c46,\r\n\t\tholdHighlightedItem: #5c5630,\r\n\t\trowWithHoldColor: #f0f0f0,\r\n\r\n\t\tbuttonPrimaryBackground: #ffffff,\r\n\t\tbuttonPrimaryBorderColor: #dddddd,\r\n\t\tbuttonPrimaryTextColor: #000000,\r\n\r\n\t\tbuttonSecondaryBackground: #000000,\r\n\t\tbuttonSecondaryBorderColor: #555555,\r\n\t\tbuttonSecondaryTextColor: #ffffff,\r\n\r\n\t\tsidebarBackground: #000000,\r\n\t\tbuttonOutlineBorder: #dddddd,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n);\r\n\r\n@mixin themed {\r\n\t@each $theme, $map in $themes {\r\n\t\t:global(.theme--#{$theme}) & {\r\n\t\t\t$theme-map: () !global;\r\n\t\t\t@each $key, $submap in $map {\r\n\t\t\t\t$value: map.get($map, $key);\r\n\t\t\t\t$theme-map: map.merge(\r\n\t\t\t\t\t$theme-map,\r\n\t\t\t\t\t(\r\n\t\t\t\t\t\t$key: $value,\r\n\t\t\t\t\t)\r\n\t\t\t\t) !global;\r\n\t\t\t}\r\n\t\t\t@content;\r\n\t\t\t$theme-map: null !global;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@function get($key) {\r\n\t@return map-get($theme-map, $key);\r\n}\r\n\r\n@mixin button-primary {\r\n\tbackground: linear-gradient(135deg, var(--textDetails), #e45210);\r\n\tcolor: white;\r\n\tborder: none;\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: linear-gradient(135deg, #e45210, #d3470e);\r\n\t\ttransform: translateY(-2px);\r\n\t}\r\n}\r\n\r\n@mixin button-secondary {\r\n\t@include themed {\r\n\t\tbackground: get(\"buttonTertiaryBackground\");\r\n\t\tcolor: get(\"buttonTertiaryColor\");\r\n\t\tborder: 1px solid get(\"buttonTertiaryBorderColor\");\r\n\t}\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: var(--textDetails);\r\n\t\tcolor: white;\r\n\t\tborder-color: var(--textDetails);\r\n\t}\r\n}\r\n\r\n@mixin card {\r\n\t@include themed {\r\n\t\tbackground: get(\"sectionBackground\");\r\n\t\tborder: 1px solid get(\"borderColor\");\r\n\t}\r\n\tborder-radius: 12px;\r\n\tpadding: 24px;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-4px);\r\n\t\tbox-shadow: 0 8px 32px rgba(245, 99, 28, 0.1);\r\n\t}\r\n}\r\n\r\n@mixin section-padding {\r\n\tpadding: 50px 0;\r\n\tborder-radius: 12px;\r\n}\r\n\r\n@mixin container {\r\n\tmax-width: 1200px;\r\n\tpadding: 0 24px;\r\n}\r\n",":root {\n  --appBlack: #000000;\n  --inactiveIcon: #8a8c91;\n  --activeIcon: white;\n  --activeIconRed: red;\n  --popupBackground: #2d2f39;\n  --legendRed: #e72416;\n  --legendYellow: #ffe08f;\n  --frontBlue: #0178ae;\n  --legendGreen: #83b643;\n  --lighterGreen: #8cff0053;\n  --textDetails: #ec6728;\n  --inputError: #d60d25;\n  --inputSuccess: #12b76a;\n  --statusBlue: #3f7bf3;\n  --sectionHeadlineText: #54778e;\n  --sfOrangeLight: #ff8e58;\n  --badgeBg: #f7ddd0;\n}\n\n.root {\n  width: 1100px;\n  max-width: 100%;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.top {\n  display: flex;\n  padding: 2rem 0;\n  overflow: auto;\n}\n@media (max-width: 900px) {\n  .top {\n    flex-direction: column;\n  }\n}\n\n:global(.theme--light) .left {\n  border-right: 1px solid #dddddd;\n  flex: 1;\n  min-width: 200px;\n  padding: 0 2rem;\n  padding-top: 2rem;\n  user-select: none;\n}\n:global(.theme--dark) .left {\n  border-right: 1px solid #2f2f2f;\n  flex: 1;\n  min-width: 200px;\n  padding: 0 2rem;\n  padding-top: 2rem;\n  user-select: none;\n}\n\n.right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 420px;\n  padding: 0 2rem;\n  padding-top: 2rem;\n}\n\n.mb {\n  margin-bottom: 16px;\n}\n\n:global(.theme--light) .subHeader {\n  color: #212121;\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n:global(.theme--dark) .subHeader {\n  color: #f0f0f0;\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n\n:global(.theme--light) .subHeaderSecondary {\n  color: #888888;\n  font-size: 1.4rem;\n}\n:global(.theme--dark) .subHeaderSecondary {\n  color: #a3a3a3;\n  font-size: 1.4rem;\n}\n\n.traitsHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n  gap: 6px;\n}\n\n.selectAll {\n  color: var(--textDetails);\n  cursor: pointer;\n  font-size: 1.4rem;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.selectAll:hover {\n  text-decoration: underline;\n}\n\n.textArea {\n  resize: vertical;\n  width: 100%;\n  min-height: 90px;\n  border-radius: 4px;\n  padding: 8px;\n  font-size: 1.4rem;\n}\n:global(.theme--light) .textArea {\n  border: 1px solid #dddddd;\n  background-color: #ffffff;\n  color: #212121;\n}\n:global(.theme--dark) .textArea {\n  border: 1px solid #2f2f2f;\n  background-color: #1c1c1c;\n  color: #f0f0f0;\n}\n\n.textArea::placeholder {\n  font-size: 1.4rem;\n}\n\n.traits {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n}\n\n.trait {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  white-space: nowrap;\n  font-size: 1.3rem;\n  font-weight: 400;\n  cursor: pointer;\n  user-select: none;\n}\n:global(.theme--light) .trait {\n  border: 1px solid #dddddd;\n  border-radius: 4px;\n  color: #888888;\n  padding: 1.2rem;\n}\n:global(.theme--dark) .trait {\n  border: 1px solid #2f2f2f;\n  border-radius: 4px;\n  color: #a3a3a3;\n  padding: 1.2rem;\n}\n.trait.checked {\n  border-color: var(--textDetails);\n}\n:global(.theme--light) .trait.checked {\n  color: #212121;\n}\n:global(.theme--dark) .trait.checked {\n  color: #f0f0f0;\n}\n\n:global(.theme--light) .warning {\n  border: 1px solid #fecdca;\n  background: #fef3f2;\n  color: #b42318;\n  padding: 1.6rem;\n  margin-top: 1.6rem;\n  border-radius: 6px;\n}\n:global(.theme--dark) .warning {\n  border: 1px solid #fecdca;\n  background: #fef3f2;\n  color: #b42318;\n  padding: 1.6rem;\n  margin-top: 1.6rem;\n  border-radius: 6px;\n}\n\n.warningHeader {\n  font-size: 1.4rem;\n  font-weight: 600;\n}\n\n.warningText {\n  font-size: 1.2rem;\n  font-weight: 400;\n}\n\n:global(.theme--light) .rightTopHeaders {\n  border-bottom: 1px solid #dddddd;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-bottom: 1.6rem;\n}\n:global(.theme--dark) .rightTopHeaders {\n  border-bottom: 1px solid #2f2f2f;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-bottom: 1.6rem;\n}\n\n:global(.theme--light) .buttons {\n  border-top: 1px solid #dddddd;\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  padding: 2rem;\n}\n:global(.theme--dark) .buttons {\n  border-top: 1px solid #2f2f2f;\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  padding: 2rem;\n}\n\n.listings {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  overflow: auto;\n}\n\n:global(.theme--light) .singleListing {\n  border-top: 1px solid #dddddd;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  border-radius: 6px;\n  padding: 6px;\n  font-size: 1.4rem;\n}\n:global(.theme--dark) .singleListing {\n  border-top: 1px solid #2f2f2f;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  border-radius: 6px;\n  padding: 6px;\n  font-size: 1.4rem;\n}\n\n.singleListing[data-no-border=true] {\n  border: none;\n}\n\n:global(.theme--light) .xContainer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  cursor: pointer;\n  width: 30px;\n  align-self: stretch;\n  align-items: start;\n}\n:global(.theme--dark) .xContainer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  cursor: pointer;\n  width: 30px;\n  align-self: stretch;\n  align-items: start;\n}\n:global(.theme--light) .xContainer div {\n  display: flex;\n  align-items: center;\n  padding: 2px;\n  justify-content: center;\n  border-radius: 6px;\n  background: #dddddd;\n  transition: 200ms;\n}\n:global(.theme--dark) .xContainer div {\n  display: flex;\n  align-items: center;\n  padding: 2px;\n  justify-content: center;\n  border-radius: 6px;\n  background: #2f2f2f;\n  transition: 200ms;\n}\n:global(.theme--light) .xContainer div:hover {\n  padding: 2px;\n  background: #888888;\n}\n:global(.theme--dark) .xContainer div:hover {\n  padding: 2px;\n  background: #a3a3a3;\n}\n\n.itemTextPrimary {\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n\n.secRowSeat {\n  flex-grow: 1;\n  min-width: 20px;\n}\n\n.headerSecRowSeat {\n  padding: 0.6rem;\n}\n\n.secRowSeatCont {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.textSecondary {\n  font-size: 1.2rem;\n  font-weight: 400;\n}\n\n:global(.theme--light) .qty {\n  color: #888888;\n  width: 45px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n:global(.theme--dark) .qty {\n  color: #a3a3a3;\n  width: 45px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n\n:global(.theme--light) .splitLabel {\n  color: #888888;\n  width: 60px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n:global(.theme--dark) .splitLabel {\n  color: #a3a3a3;\n  width: 60px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n\n:global(.theme--light) .priceLabel {\n  color: #888888;\n  width: 90px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n:global(.theme--dark) .priceLabel {\n  color: #a3a3a3;\n  width: 90px;\n  padding: 0.6rem;\n  flex-shrink: 0;\n}\n\n.notePills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  align-items: center;\n  margin-top: 2px;\n}\n\n:global(.theme--light) .hasNotes {\n  color: #888888;\n  border: 1px solid #dddddd;\n  border-radius: 28px;\n  padding: 3px 8px;\n  font-size: 1.1rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n:global(.theme--dark) .hasNotes {\n  color: #a3a3a3;\n  border: 1px solid #2f2f2f;\n  border-radius: 28px;\n  padding: 3px 8px;\n  font-size: 1.1rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.noNotes {\n  font-style: italic;\n  opacity: 0.7;\n}\n\n.notePill {\n  font-weight: 500;\n  font-size: 1.1rem;\n  border-radius: 28px;\n  padding: 3px 8px;\n  white-space: nowrap;\n}\n:global(.theme--light) .notePill {\n  border: 1px solid #dddddd;\n  background-color: #ddddda;\n  color: #212121;\n}\n:global(.theme--dark) .notePill {\n  border: 1px solid #2f2f2f;\n  background-color: #2f2f2f;\n  color: #f0f0f0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `BulkExternalNotes-module_root___s8ZpV`,
	"top": `BulkExternalNotes-module_top___m5sxd`,
	"left": `BulkExternalNotes-module_left___vpeF8`,
	"right": `BulkExternalNotes-module_right___BTRGw`,
	"mb": `BulkExternalNotes-module_mb___sbtEV`,
	"subHeader": `BulkExternalNotes-module_subHeader___NcEUv`,
	"subHeaderSecondary": `BulkExternalNotes-module_subHeaderSecondary____M4dw`,
	"traitsHeader": `BulkExternalNotes-module_traitsHeader___hTEwU`,
	"selectAll": `BulkExternalNotes-module_selectAll___ZZyP9`,
	"textArea": `BulkExternalNotes-module_textArea___gHroW`,
	"traits": `BulkExternalNotes-module_traits___kAumG`,
	"trait": `BulkExternalNotes-module_trait___t3P1R`,
	"checked": `BulkExternalNotes-module_checked___Dxr8e`,
	"warning": `BulkExternalNotes-module_warning___ip3iA`,
	"warningHeader": `BulkExternalNotes-module_warningHeader___bVqg_`,
	"warningText": `BulkExternalNotes-module_warningText___kRsL8`,
	"rightTopHeaders": `BulkExternalNotes-module_rightTopHeaders___iPhuD`,
	"buttons": `BulkExternalNotes-module_buttons___v_eR_`,
	"listings": `BulkExternalNotes-module_listings___qirPA`,
	"singleListing": `BulkExternalNotes-module_singleListing___m5cqR`,
	"xContainer": `BulkExternalNotes-module_xContainer___AtWze`,
	"itemTextPrimary": `BulkExternalNotes-module_itemTextPrimary___mMLgI`,
	"secRowSeat": `BulkExternalNotes-module_secRowSeat___gGkX_`,
	"headerSecRowSeat": `BulkExternalNotes-module_headerSecRowSeat___LcfkY`,
	"secRowSeatCont": `BulkExternalNotes-module_secRowSeatCont___CwSVY`,
	"textSecondary": `BulkExternalNotes-module_textSecondary___Z7X72`,
	"qty": `BulkExternalNotes-module_qty___LUc9m`,
	"splitLabel": `BulkExternalNotes-module_splitLabel___DeJVR`,
	"priceLabel": `BulkExternalNotes-module_priceLabel___MuNK6`,
	"notePills": `BulkExternalNotes-module_notePills___uiYHg`,
	"hasNotes": `BulkExternalNotes-module_hasNotes___tN9HE`,
	"noNotes": `BulkExternalNotes-module_noNotes___JDQYL`,
	"notePill": `BulkExternalNotes-module_notePill___a2CMC`
};
export default ___CSS_LOADER_EXPORT___;
